import { render, staticRenderFns } from "./HeaderCart.vue?vue&type=template&id=20622a14&scoped=true"
import script from "./HeaderCart.vue?vue&type=script&lang=js"
export * from "./HeaderCart.vue?vue&type=script&lang=js"
import style0 from "./HeaderCart.vue?vue&type=style&index=0&id=20622a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20622a14",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderBadge: require('/app/components/HeaderBadge.vue').default,CartProductList: require('/app/components/CartProductList.vue').default})
